<template>
  <router-link :to="{ name: 'DashboardMessages', query: { home_id: $route.query.home_id } }"
               title="Chatter sur COOLOC" tag="div" class="menu-icon menu-chat">
    <div>
      <img src="/static/images/icons/Message.svg"/>
      <span v-if="nb_unread > 0" class="counter">{{ nb_unread }}</span>
    </div>
  </router-link>
</template>

<script>
import unreadCountMixin from '../mixins/unreadCount'
export default {
  mixins: [unreadCountMixin],
  name: 'header-menu-chat',
}
</script>
